import { Rect } from "fabric";
import { useEffect } from "react";
import { InteractableCanvasElementProps } from "./Canvas";

type Props = {
  x: number;
  width: number;
  color: string;
  opacity: number;
  draggable: boolean;
} & InteractableCanvasElementProps;

const Column = (props: Props) => {
  if (props.canvas == null) {
    throw new Error("Canvas Elements must the canvas prop passed");
  }
  useEffect(() => {
    const column = new Rect({
      lockRotation: true,
      // height cannot be controlled
      lockMovementY: true,
      lockMovementX: true,
      // can move left to right
      hasControls: false,
      // hover cursor no plz ?
      // hoverCursor: props.draggable,
      // set height to canvases height
      // @ts-expect-error
      height: props.canvas.getHeight(),
      top: 0,
      left: props.x,
      width: props.width,
      fill: props.color,
      opacity: props.opacity,
      data: {
        id: props.id,
      },
    });
    column.setControlVisible("mtr", false);
    props.canvas!.add(column);
    return function cleanupHighlight() {
      props.canvas!.remove(column);
    };
  });

  return null;
};

export { Column };
